<div *ngIf="!loading">
<p-table [value]="cardNotes" *ngIf="cardNotes.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 50px;">L.p</th>
            <th style="width: 100%;">{{'cart_table_header_name' | translate}}</th>
            <th style="width: 80px;">{{'cart_table_header_price' | translate}}</th>
            <th *ngIf="!readonly" style="width: 60px;">{{'cart_table_header_delete_btn' | translate}}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note let-rowIndex="rowIndex">
        <tr>
            <td style="text-align: center;padding: 20px">{{rowIndex + 1}}</td>
            <td style="text-overflow: ellipsis;overflow: hidden;">{{note.title}}</td>
            <td>{{note.price | currencyReduce | currency: selectedCurrency}}</td>
            <td *ngIf="!readonly" style="text-align: center;font-size: 16px;"> <span (click)="onDeleteItem(note)" style="cursor: pointer;"><i class="pi pi-trash"></i></span></td>
        </tr>
    </ng-template>
     
</p-table>

<div *ngIf="cardNotes.length == 0 && !loading">
    <h2 style="margin: 0 0 16px; font-size: 30px;"><span style="color:#84949f;font-weight: normal;">{{'cart_empty' | translate}}</span></h2>
    <div>{{'cart_description_2' | translate}}</div>
</div>


<br/>



</div>
<app-loader *ngIf="loading"></app-loader>

